module.exports = __webpack_public_path__ + "static/media/picture-icon.17601d1b.svg";